import { useEffect, useState } from "react";
import { API_BASE } from "../config/api";

export function useLandingPageData() {
  const [data, setData] = useState({ sections: {}, items: {} });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let ignore = false;

    async function load() {
      try {
        setLoading(true);
        setError("");

        const res = await fetch(`${API_BASE}/landing-page`);
        const payload = await res.json();

        if (!res.ok) {
          throw new Error(payload.error || "Failed to load landing page content");
        }

        if (!ignore) {
          setData({
            sections: payload.sections || {},
            items: payload.items || {},
          });
        }
      } catch (err) {
        if (!ignore) {
          setError(err.message);
        }
      } finally {
        if (!ignore) {
          setLoading(false);
        }
      }
    }

    load();
    return () => {
      ignore = true;
    };
  }, []);

  return { data, loading, error };
}
